module.exports = __webpack_public_path__ + "static/media/google.cac2bcd1.png";